import { AuthenticationManager } from '@frontend/authentication-v2';
import { Logger } from '@frontend/logger';
import { PushNotificationReceiverClient } from '@frontend/push-notification/api';
import { ToastUtil } from '@frontend/toast-utils';
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';
import { useEffect } from 'react';

import { messaging, vapidKey } from '../../firebase.config';
import { swRegistration } from '../../serviceWorkerRegistration';

export const PushNotifications = (props: { children: React.ReactNode }) => {
    useEffect(() => {
        isSupported().then((supported) => {
            if (!supported) return;
            AuthenticationManager.getInstance()
                .getTokenWhenReady()
                .then(() => {
                    requestNotificationPermissions().then(() => {
                        onMessage(getMessaging(), (payload) => {
                            ToastUtil.info(payload.notification?.title, payload.notification?.body);
                        });
                    });
                });
        });
    }, []);

    return props.children;
};

export default PushNotifications;

export const requestNotificationPermissions = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
            Logger.log('Notification permission granted.');
            const m = await messaging;
            if (!m) {
                Logger.log('Firebase Messaging not supported in this browser.');
                return;
            }
            const token = await getToken(m, { vapidKey, serviceWorkerRegistration: swRegistration ?? undefined });
            if (token) {
                let deviceIdentifier = window.localStorage.getItem('fcm-device-token');
                if (!deviceIdentifier) {
                    deviceIdentifier = crypto.randomUUID();
                    window.localStorage.setItem('fcm-device-token', deviceIdentifier);
                }
                await PushNotificationReceiverClient.registerPushNotificationReceiver({ identifier: deviceIdentifier, token: token }).then(() => {
                    Logger.log('FCM registration token server sync done:', token, deviceIdentifier);
                });
            } else {
                Logger.log('No FCM registration token available. Request permission first.');
            }
        } else {
            Logger.log('Notification permission denied.');
        }
    } catch (error) {
        Logger.error('Error requesting notification permission:', error);
    }
};
